import React, { useContext, useEffect } from 'react';
import { Badge, Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md'
import { AiFillCaretDown } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';

import { get_sounds_data } from '../../../Controller/actions';
import { NewContext } from '../../../Context/NewContext';
import PaginationCmp from '../../../Components/Pagination/PaginationCmp';
import { Header } from '../../../Components/Header';

import './sounds.css';
import { THead } from '../../../Components/Table';

export const Sounds = ({ title }) => {
  const navigate = useNavigate();
  const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleCheckboxChange } = useContext(NewContext);
  const simpleFields = ["Id", "Name", "Preview", "Mp3 File"];
  const dropdownFields = ["Premium", "Active"];
  const totalFields = simpleFields.length + dropdownFields.length + 2;

  let handleSwitch = (e) => {
    setDeleteUpdateYes("updatesound");
    setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
    setConfirmationModalShow(!confirmationModalShow)
  };

  const getSoundsData = async (_currentPage = 1) => {
    setIsLoading(true);
    try {
      const getSounds = await get_sounds_data(_currentPage, perPage, search, filterDropdown);
      if (getSounds) {
        const { status, data, currentPage, perPage, totalPage } = getSounds;
        if (status) {
          console.log(data);
          setCurrentTableData(data);
          setCurrentPage(currentPage);
          setPerPage(perPage);
          setTotalPage(totalPage);
        } else {
          // toast.error(message);
          setCurrentTableData([]);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getSoundsData(currentPage);
  }, [deleteUpdateTag, search, filterDropdown]);

  useEffect(() => {
    document.title = `Emoji Keyboard | ${title}`
  }, []);

  return (
    <div className='table-header-main ms-auto p-3'>
      <Header title={`Sounds`} previewLink={`/preview`} addLink={`/soundsform`} deleteUpdateTag={"alldeletesounds"} />
      <Table striped bordered hover responsive className='mb-3'>
        <THead
          simpleFields={simpleFields}
          dropdownFields={dropdownFields}
        />
        <tbody>
          {
            isLoading ?
              <tr>
                <td colSpan={totalFields} className='py-5'>
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" />
                  </div>
                </td>
              </tr>
              : currentTableData.length === 0 ?
                <tr>
                  <td colSpan={totalFields} className='py-5 bg-light'>
                    <div className="d-flex justify-content-center align-items-center">
                      No Data Found
                    </div>
                  </td>
                </tr>
                : currentTableData.map((_ele, i) => (
                  <tr key={i} className="align-middle">
                    <td>
                      <Form.Check
                        type={'checkbox'}
                        id={`sounds-${_ele._id}`}
                        value={`${_ele._id}`}
                        checked={checkedValues.includes(`${_ele._id}`)}
                        onChange={() => handleCheckboxChange(`${_ele._id}`)}
                      />
                    </td>
                    <td>{perPage * (currentPage - 1) + (i + 1)}</td>
                    <td>{_ele.name}</td>
                    <td>
                      <div className='imgTd position-relative'>
                        <img className='table-preview_img position-absolute d-block' src={`${_ele.preview ? `${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                        <Zoom>
                          <img className='table-preview_img d-block' src={`${_ele.preview ? `${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                        </Zoom>
                      </div>
                    </td>
                    <td><audio src={_ele.mp3file} controls className='table-audio' /></td>
                    {
                      ["isPremium", "isActive"].map((_is_ele, i) => (
                        <td key={i}>
                          {/* <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal">
                            {_is_ele ? `On` : `Off`}
                          </Badge> */}
                          <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitch} checked={_ele[_is_ele]} role="button" />
                        </td>
                      ))
                    }
                    <td>
                      <div className='d-flex action-btns'>
                        {/* <TooltipCmp placement={`top`} tooltipText={copyText}> */}
                        <Button className='p-2 me-2' variant="info" onClick={() => handleCopyData(_ele)}>
                          <MdFileCopy color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}

                        {/* <TooltipCmp placement={`top`} tooltipText={`Edit`}> */}
                        <Button className='p-2 me-2' variant="warning" onClick={() => navigate(`/soundsform`, { state: _ele })}>
                          <MdEditSquare color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}

                        {/* <TooltipCmp placement={`top`} tooltipText={`Delete`}> */}
                        <Button className='p-2 me-2' variant="danger" onClick={() => { setDeleteUpdateYes("deletesounds"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                          <MdDelete color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}
                      </div>
                    </td>
                  </tr>
                ))
          }
        </tbody>
      </Table>
      <div className={`table-pagination d-flex justify-content-end ${currentTableData.length > 0 ? 'd-block' : 'd-none'}`}>
        <PaginationCmp
          currentPage={currentPage}
          totalPage={totalPage}
          getData={getSoundsData}
        />
      </div>
    </div>
  )
};

Sounds.defaultProps = {
  title: "Sounds"
};

export default Sounds;